export function scrollRight(anims, calcs, stateAnims, dirAnim) {
    let t = anims[dirAnim] - calcs.step * calcs.multiplier;
    let d = calcs.container - calcs.wrapper;
    anims[dirAnim] = Math.abs(t) > d ? d * -1 : t;
    let animationDirection = {};
    animationDirection[dirAnim] = anims[dirAnim].toString() + "px";
    let o = Object.assign(Object.assign({}, stateAnims), { animation: animationDirection });
    return { anims: Object.assign({}, o) };
}
//# sourceMappingURL=scrollRight.js.map